var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "avue-crud",
        _vm._g(
          _vm._b(
            {
              attrs: { page: _vm.page },
              on: {
                "update:page": function ($event) {
                  _vm.page = $event
                },
                "on-load": _vm.getList,
                "refresh-change": _vm.refreshChange,
                "search-reset": _vm.searchChange,
                "search-change": _vm.searchChange,
              },
              model: {
                value: _vm.formData,
                callback: function ($$v) {
                  _vm.formData = $$v
                },
                expression: "formData",
              },
            },
            "avue-crud",
            _vm.bindVal,
            false
          ),
          _vm.onEvent
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }